export class AppSettings {
  MIN_DEFAULT_LENGTH = 1;
  MAX_DEFAULT_LENGTH = 255;
  MIN_PASSWORD_LENGTH = 6;
}
